export class DashboardThumbnailCache {
  static cache = {};

  static get(key) {
    return this.cache[key];
  }

  static set(key, value) {
    this.cache[key] = value;
  }

  static delete(key) {
    delete this.cache[key];
  }

  static deleteAll() {
    this.cache = {};
  }

  static has(key) {
    return Object.prototype.hasOwnProperty.call(this.cache, key);
  }
}
